import { render, staticRenderFns } from "./EmergenceData.vue?vue&type=template&id=7f131d30&"
import script from "./EmergenceData.vue?vue&type=script&lang=js&"
export * from "./EmergenceData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports